import RequireAuth from "@/auth/RequireAuth"
import { Route } from "react-router-dom"
import type { RouteProps } from "react-router-dom"
import type { AuthRouteProps } from "./routes"

const renderRoutes = (routes: RouteProps[]) => {
  return (
    routes.map((route: AuthRouteProps, i: number) => {
      const Comp = route.element as any
      return route.isAuthenticated ? (
        <Route
          // eslint-disable-next-line
          key={i}
          path={route.path}
          element={
            <RequireAuth>
              <Comp />
            </RequireAuth>
          }
        />
      ) : (
        // eslint-disable-next-line
        <Route key={i} path={route.path} element={<Comp />} />
      )
    }) || []
  )
}

export default renderRoutes
